import {
  Box,
  Button,
  Checkbox,
  Container,
  Divider,
  Grid,
  TextField,
  Snackbar,
  Alert,
  AlertTitle,
  Autocomplete,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Link,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import {
  createCustomer,
  getAllCountry,
  getCustomerByID,
  getCustomerStaticDataByCustID,
  getParentCustomers,
  removeCustomerLogo,
  updateCustomer,
} from "../redux/actions/AdminAction";
import {
  CREATE_CUSTOMER_RESET,
  GET_CUSTOMER_RESET,
  GET_CUSTOMER_STATIC_DATA_RESET,
  UPDATE_CUSTOMER_RESET,
} from "../Constants/Constants";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const modalStyle = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const getPccSet = (pccs = "") =>
  new Set(
    String(pccs)
      .split(/[\s,]+/)
      .map((pcc) => pcc.trim().toUpperCase())
      .filter(Boolean)
  );

const hasNewPcc = (previousPccs, currentPccs) => {
  const previous = getPccSet(previousPccs);
  return [...getPccSet(currentPccs)].some((pcc) => !previous.has(pcc));
};

export default function Customer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const languageOptions = [
    { value: "en", label: "English" },
    { value: "fr", label: "French" },
    { value: "tr", label: "Turkish" },
  
  ];
  const languageOptionsForReport = [
    { value: "en", label: "English" },
    { value: "fr", label: "French" },
   
  ];
  const token = JSON.parse(localStorage.getItem("userInfo"));

  const [snackOpen, setSnackOpen] = useState(false);
  const [logo, setlogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoRemoved, setLogoRemoved] = useState(false);
  const [footerLogo, setFooterLogo] = useState(null);
  const [footerLogoPreview, setFooterLogoPreview] = useState(null);
  const [footerLogoRemoved, setFooterLogoRemoved] = useState(false);
  const [customer_name, setCustomer_name] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [isReportEnabled, setIsReportEnabled] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [cc, setCC] = useState("");
  const [ccError, setCCError] = useState("");
  const [PCCs, setPCCs] = useState("");
  const [reportFieldTouched, setReportFieldTouched] = useState(false);
  const [language, setLanguage] = useState("en");
  const [reportLanguage, setReportLanguage] = useState("en");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [postalCode, setpostalCode] = useState("");
  const [postalCodeError, setPostalCodeError] = useState("");
  const [country, setCountry] = useState("");
  const [countries, setCountries] = useState([]);
  const [telephone_number, setTelephone_number] = useState("");
  const [telephoneNumberError, setTelephoneNumberError] = useState("");
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertTitle, setErrorAlertTitle] = useState("");
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [logoUploadError, setLogoUploadError] = useState("");
  const [footerLogoUploadError, setFooterLogoUploadError] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [saveMessage, setSaveMessage] = useState("");
  const [saveMessageOpen, setSaveMessageOpen] = useState(false);
  const [is_child, setIs_child] = useState(false);
  const [parent_id, setParent_id] = useState(null);

  // Customer static data
  const [suppliers, setSuppliers] = useState(null);
  const [client, setClient] = useState(null);
  const [type, setType] = useState(null);
  const [destination, setDestination] = useState(null);
  const [total_fares, setTotal_Fares] = useState(null);
  const [discount, setDiscount] = useState(null);
  const [fop, setFOP] = useState(null);
  const [etkt, setETKT] = useState(null);
  const [office_id, setOffice_id] = useState(null);
  const [gds, setGDS] = useState(null);

  const [contact_person, setContact_person] = useState("");

  const CreateCustomer = useSelector((state) => state.CreateCustomer);
  const { customerInfo, error } = CreateCustomer;

  const GetCustomerByID = useSelector((state) => state.GetCustomerByID);
  const { customerById } = GetCustomerByID;

  const GetCustomerStaticDataByCustID = useSelector(
    (state) => state.GetCustomerStaticDataByCustID
  );
  const { customerStaticDataInfo } = GetCustomerStaticDataByCustID;

  const UpdateCustomer = useSelector((state) => state.UpdateCustomer);
  const { success, message, updateerror } = UpdateCustomer;

  const GetAllCountry = useSelector((state) => state.GetAllCountry);
  const { countryInfo } = GetAllCountry;

  const GetParentCustomers = useSelector((state) => state.GetParentCustomers);
  const { parentCustomersInfo } = GetParentCustomers;

  useEffect(() => {
    dispatch({ type: GET_CUSTOMER_RESET });
    dispatch({ type: GET_CUSTOMER_STATIC_DATA_RESET });
    dispatch({ type: UPDATE_CUSTOMER_RESET });
    dispatch(getAllCountry());
  }, []);

  useEffect(() => {
    if (is_child) {
      dispatch(getParentCustomers());
    }
  }, [is_child]);

  useEffect(() => {
    if (!token) {
      navigate("/");
    }
  }, [navigate, token]);

  useEffect(() => {
    if (id === "new") {
      setlogo(null);
      setLogoPreview(null);
      setLogoRemoved(false);
      setFooterLogo(null);
      setFooterLogoPreview(null);
      setFooterLogoRemoved(false);
      setLogoUploadError("");
      setFooterLogoUploadError("");
      setCustomer_name("");
      setIsActive(false);
      setIsReportEnabled(false);
      setReportFieldTouched(false);
      setEmail("");
      setCC("");
      setPCCs("");
      setLanguage("en");
      setReportLanguage("en");
      setAddress1("");
      setAddress2("");
      setCity("");
      setpostalCode("");
      setCountry("");
      setTelephone_number("");
      setContact_person("");
      setIs_child(false);
      setParent_id(null);

      //static data
      setSuppliers(null);
      setClient(null);
      setType(null);
      setDestination(null);
      setTotal_Fares(null);
      setDiscount(null);
      setFOP(null);
      setETKT(null);
      setOffice_id(null);
      setGDS(null);

      dispatch({ type: GET_CUSTOMER_RESET });
      dispatch({ type: GET_CUSTOMER_STATIC_DATA_RESET });
      dispatch({ type: UPDATE_CUSTOMER_RESET });
      dispatch(getAllCountry());
    } else {
      dispatch({ type: UPDATE_CUSTOMER_RESET });
      dispatch(getCustomerByID(id));
      dispatch(getCustomerStaticDataByCustID(id));
      dispatch(getAllCountry());
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (customerById) {
      setLogoPreview(null);
      setFooterLogoPreview(null);
      setLogoRemoved(false);
      setFooterLogoRemoved(false);
      setlogo(customerById?.logo?.trim() || null);
      setFooterLogo(customerById?.footer_logo?.trim() || null);
      setCustomer_name(customerById?.customer_name?.trim() || "");
      setIsActive(customerById?.active || false);
      setIsReportEnabled(customerById?.is_report_enabled || false);
      setReportFieldTouched(false);
      setEmail(customerById?.email?.trim() || "");
      setCC(customerById?.cc?.trim() || "");
      setPCCs(customerById?.pccs?.trim() || "");
      setLanguage(customerById?.language?.trim() || "");
      setReportLanguage(
        customerById?.report_language?.trim() ||
          customerById?.language?.trim() ||
          "en"
      );
      setAddress1(customerById?.address_1?.trim() || "");
      setAddress2(customerById?.address_2?.trim() || "");
      setCity(customerById?.city?.trim() || "");
      setpostalCode(customerById?.postal_code?.trim() || "");
      setCountry(customerById?.country?.trim() || "");
      setTelephone_number(customerById?.telephone_number?.trim() || "");
      setContact_person(customerById?.contact_person?.trim() || "");
      setParent_id(customerById?.parent_id || null);
      setIs_child(customerById?.parent_id ? true : false);
    }
  }, [customerById]);

  useEffect(() => {
    if (customerStaticDataInfo) {
      setSuppliers(customerStaticDataInfo?.fournisseur?.trim() || null);
      setClient(customerStaticDataInfo?.client?.trim() || null);
      setType(customerStaticDataInfo?.type?.trim() || null);
      setDestination(customerStaticDataInfo?.destination?.trim() || null);
      setTotal_Fares(customerStaticDataInfo?.total_frais?.trim() || null);
      setDiscount(customerStaticDataInfo?.remise?.trim() || null);
      setFOP(customerStaticDataInfo?.fop?.trim() || null);
      setETKT(customerStaticDataInfo?.etkt?.trim() || null);
      setOffice_id(customerStaticDataInfo?.office_id?.trim() || null);
      setGDS(customerStaticDataInfo?.gds?.trim() || null);
    }
  }, [customerStaticDataInfo]);

  useEffect(() => {
    if (countryInfo) {
      setCountries(countryInfo);
    }
  }, [countryInfo]);

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSaveMessageCancel = () => {
    setSaveMessageOpen(false);
    navigate("/managecustomer");
  };

  const handleValidatedImageUpload = (
    selectedFile,
    setFile,
    setPreview,
    setError
  ) => {
    if (!selectedFile) {
      return;
    }

    const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
    if (!allowedTypes.includes(selectedFile?.type)) {
      setError("Only JPG, PNG, and GIF files are allowed.");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const image = new Image();
      image.src = reader.result;
      image.onload = () => {
        if (image.width > 1300 || image.height > 400) {
          setError("Image dimensions should not exceed 400x1300 pixels.");
        } else {
          setFile(selectedFile);
          setPreview(reader.result);
          setError("");
        }
      };
    };
    reader.readAsDataURL(selectedFile);
  };

  const handleImageChange = (e) => {
    handleValidatedImageUpload(
      e.target.files[0],
      setlogo,
      setLogoPreview,
      setLogoUploadError
    );
    setLogoRemoved(false);
  };

  const handleFooterImageChange = (e) => {
    handleValidatedImageUpload(
      e.target.files[0],
      setFooterLogo,
      setFooterLogoPreview,
      setFooterLogoUploadError
    );
    setFooterLogoRemoved(false);
  };

  const handleImageRemove = () => {
    setlogo(null);
    setLogoPreview(null);
    setLogoUploadError("");
    setLogoRemoved(true);
  };

  const handleFooterImageRemove = () => {
    setFooterLogo(null);
    setFooterLogoPreview(null);
    setFooterLogoUploadError("");
    setFooterLogoRemoved(true);
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
    setErrorAlert(false);
  };

  const handleIsActive = (event) => {
    setIsActive(event.target.checked);
  };

  const handleIsReportEnabled = (event) => {
    setReportFieldTouched(true);
    setIsReportEnabled(event.target.checked);
  };

  const handleIsChildEnabled = (event) => {
    setIs_child(event.target.checked);
  };

  const handleLanguage = (event) => {
    setLanguage(event.target.value);
  };

  const handleReportLanguage = (event) => {
    setReportLanguage(event.target.value);
  };

  const validateEmail = (email) => {
    // Basic email validation regex
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleEmail = (event) => {
    const enteredValues = event.target.value
      .split("\n")
      .map((value) => value?.trim());

    const invalidEmails = enteredValues.filter(
      (email) => email && !validateEmail(email)
    );

    if (invalidEmails.length > 0) {
      setEmailError(`Invalid email addresses: ${invalidEmails.join(", ")}`);
    } else {
      setEmailError("");
    }
    const enteredEmail = enteredValues.join(" ");

    setEmail(enteredEmail);
  };

  const handleCC = (event) => {
    const enteredValues = event.target.value
      .split("\n")
      .map((value) => value?.trim());

    const invalidEmails = enteredValues.filter(
      (email) => email && !validateEmail(email)
    );

    if (invalidEmails.length > 0) {
      setCCError(`Invalid email addresses: ${invalidEmails.join(", ")}`);
    } else {
      setCCError("");
    }
    const enteredEmail = enteredValues.join(" ");

    setCC(enteredEmail);
  };

  const handlePCCs = (event) => {
    const enteredValues = event.target.value
      .split("\n")
      .map((value) => value?.trim());
    const pccs = enteredValues.join(" ");
    setPCCs(pccs);
  };

  const validatePostalCode = (code) => {
    // Example validation: Postal code should be 5 digits long
    const regex = /^[a-zA-Z0-9]{5,10}$/;
    return regex.test(code);
  };

  const handlePostalCodeChange = (e) => {
    const code = e.target.value;

    // Allow only numeric input
    if (/^[a-zA-Z0-9]*$/.test(code)) {
      setpostalCode(code);

      // Validate the postal code
      if (code && !validatePostalCode(code)) {
        setPostalCodeError(
          "The postal code must consist of between 5 and 10 digits."
        );
      } else {
        setPostalCodeError("");
      }
    }
  };

  const validateTelephoneNumber = (number) => {
    // Validation: Allow numbers with or without + and country code
    // Option 1: + followed by 06-15 digits
    // Option 2: 06-15 digits
    const regex = /^(?:\+\d{1,4})?\d{6,15}$/;
    return regex.test(number);
  };

  const handleTelephoneNumberChange = (e) => {
    const number = e.target.value;

    // Allow only valid characters: digits and +
    if (/^[+\d]*$/.test(number)) {
      setTelephone_number(number);

      if (number && !validateTelephoneNumber(number)) {
        setTelephoneNumberError(
          "Telephone number should be between 06-15 digits, with or without a leading + and country code."
        );
      } else {
        setTelephoneNumberError("");
      }
    }
  };

  const submitHandler = () => {
    if (emailError || postalCodeError || telephoneNumberError) {
      setErrorAlertTitle("Invalid values in the field.");
      setErrorAlertMessage("Please enter the fields properly.");
      setErrorAlert(true);
      setSnackOpen(true);
      return;
    }
    if (
      customer_name &&
      email &&
      PCCs &&
      address1 &&
      address2 &&
      city &&
      postalCode &&
      country &&
      contact_person
    ) {
      const newPccAdded = hasNewPcc(
        id === "new" ? "" : customerById?.pccs,
        PCCs
      );

      const customer = {
        customer_name: customer_name?.trim(),
        email: email?.trim(),
        cc: cc || "",
        pccs: PCCs?.trim(),
        role: "user",
        language: language,
        report_language: reportLanguage,
        active: isActive || false,
        is_report_enabled: isReportEnabled || false,
        address_1: address1,
        address_2: address2,
        city: city,
        postal_code: postalCode,
        country: country,
        telephone_number: telephone_number,
        contact_person: contact_person,
        parent_id: is_child ? parent_id : null,
      };
      const static_data = {
        id: customerStaticDataInfo?.static_data_id || "",
        fournisseur: suppliers || "",
        client: client || "",
        type: type || "",
        destination: destination || "",
        total_frais: total_fares || "",
        remise: discount || "",
        fop: fop || "",
        etkt: etkt || "",
        office_id: office_id || "",
        gds: gds || "",
      };
      const isNewCustomer = id === "new";
      const reportButtonTouched = isNewCustomer
        ? reportFieldTouched || isReportEnabled
        : reportFieldTouched;
      const showSyncMessage = isNewCustomer
        ? isReportEnabled
        : reportButtonTouched || newPccAdded;
      const syncMessage = isNewCustomer
        ? "You have now added the customer with Ticket Report access. Please allow up to 24 hours for the Ticket Report data to sync properly for this customer, as the data synchronization is performed through an automated process."
        : "You have now updated the customer with Ticket Report access. Please allow up to 24 hours for the Ticket Report data to sync properly for this customer, as the data synchronization is performed through an automated process.";
      const defaultMessage = isNewCustomer
        ? "Customer added successfully."
        : "Customer updated successfully.";
      if (id === "new") {
        dispatch(createCustomer(customer, static_data, logo, footerLogo));
        setSnackOpen(!showSyncMessage);

        setlogo("");
        setLogoPreview(null);
        setLogoRemoved(false);
        setFooterLogo("");
        setFooterLogoPreview(null);
        setFooterLogoRemoved(false);
        setFooterLogoUploadError("");
        setCustomer_name("");
        setIsActive(false);
        setIsReportEnabled(false);
        setEmail("");
        setCC("");
        setPCCs("");
        setLanguage("en");
        setReportLanguage("en");
        setAddress1("");
        setAddress2("");
        setCity("");
        setpostalCode("");
        setCountry("");
        setTelephone_number("");
        setContact_person("");
        dispatch({ type: CREATE_CUSTOMER_RESET });

        //static data
        setSuppliers(null);
        setClient(null);
        setType(null);
        setDestination(null);
        setTotal_Fares(null);
        setDiscount(null);
        setFOP(null);
        setETKT(null);
        setOffice_id(null);
        setGDS(null);

      } else {
        dispatch({ type: CREATE_CUSTOMER_RESET });
        dispatch(updateCustomer(id, customer, static_data, logo, footerLogo));
        if (id && customerById && customerById?.logo && logoRemoved) {
          dispatch(removeCustomerLogo(id));
        }
        setSnackOpen(!showSyncMessage);
      }
      setSaveMessage(showSyncMessage ? syncMessage : defaultMessage);
      setSaveMessageOpen(showSyncMessage);
      if (!showSyncMessage) {
        setTimeout(() => {
          navigate("/managecustomer");
        }, 3000);
      }
    } else {
      setErrorAlertTitle("Required field error");
      setErrorAlertMessage("Please enter the required fields.");
      setSnackOpen(true);
      setErrorAlert(true);
    }
  };

  const renderImageUploadCard = ({
    title,
    file,
    preview,
    error,
    onChange,
    onRemove,
    uploadLabel,
    imageAlt,
  }) => (
    <Grid item xs={12} md={6}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          {title}
        </Grid>
        <Grid item xs={12} mt={1}>
          {file && !preview && (
            <Grid item xs={12}>
              <img
                src={`data:image/png;base64,${file}`}
                alt={imageAlt}
                style={{ maxWidth: "100%", maxHeight: "200px" }}
              />
            </Grid>
          )}
          {preview && (
            <Grid item xs={12}>
              <img
                src={preview}
                alt={imageAlt}
                style={{ maxWidth: "100%", maxHeight: "200px" }}
              />
            </Grid>
          )}
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
            sx={{ backgroundColor: "#282828" }}
          >
            {uploadLabel}
            <VisuallyHiddenInput type="file" onChange={onChange} />
          </Button>
          {file && (
            <Button
              sx={{
                marginLeft: 2,
                backgroundColor: "#282828",
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: "#282828",
                  color: "#ffffff",
                },
              }}
              variant="contained"
              startIcon={<DeleteForeverIcon />}
              onClick={onRemove}
            >
              Remove
            </Button>
          )}
        </Grid>
        {!preview && !file && !error && (
          <Grid item xs={12} sx={{ fontSize: 12 }} mt={1}>
            Only JPG, PNG, and GIF files are allowed.
            <br /> Image dimensions should not exceed 520x150 pixels.
          </Grid>
        )}
        {error && (
          <Grid item xs={12} sx={{ fontSize: 12, color: "red" }} mt={1}>
            {error}
          </Grid>
        )}
      </Grid>
    </Grid>
  );

  return (
    <Container sx={{ marginBottom: "5%" }}>
      <Box>
        <Box sx={{ margin: 3, fontSize: 25 }}>
          Manage your customers
          <Divider sx={{ marginTop: 2 }}></Divider>
        </Box>
        <Box sx={{ fontSize: 25, margin: 3 }}>
          {id === "new" ? "Add Customer" : "Edit Customer"}
        </Box>
        <Box sx={{ margin: 3 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              Make this customer a child customer
              <Checkbox checked={is_child} onChange={handleIsChildEnabled} />
            </Grid>
            {is_child && (
              <Grid item xs={12} mt={2}>
                <Grid item xs={6}>
                  Select Parent Customer
                </Grid>
                <Grid item xs={6} mt={1}>
                  <Autocomplete
                    fullWidth
                    options={
                      (parentCustomersInfo &&
                        Object.values(parentCustomersInfo)) ||
                      []
                    }
                    getOptionLabel={(option) =>
                      option?.customer_name?.trim() || ""
                    }
                    value={
                      (parentCustomersInfo &&
                        parentCustomersInfo.find(
                          (customer) => customer?.customer_id === parent_id
                        )) ||
                      null
                    }
                    onChange={(event, newValue) =>
                      setParent_id(newValue.customer_id)
                    }
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" />
                    )}
                  />
                </Grid>
              </Grid>
            )}
            <Grid item xs={12} mt={2}>
              <Grid container spacing={2} alignItems="flex-start">
                {renderImageUploadCard({
                  title: "Header image",
                  file: logo,
                  preview: logoPreview,
                  error: logoUploadError,
                  onChange: handleImageChange,
                  onRemove: handleImageRemove,
                  uploadLabel: "Upload Header",
                  imageAlt: "Header",
                })}
                {renderImageUploadCard({
                  title: "Footer image",
                  file: footerLogo,
                  preview: footerLogoPreview,
                  error: footerLogoUploadError,
                  onChange: handleFooterImageChange,
                  onRemove: handleFooterImageRemove,
                  uploadLabel: "Upload footer",
                  imageAlt: "Footer image",
                })}
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                Customer name <span style={{ color: "red" }}>*</span>
              </Grid>
              <Grid item xs={6} mt={1}>
                <TextField
                  fullWidth
                  required
                  value={customer_name}
                  onChange={(e) => setCustomer_name(e.target.value)}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              Active?
              <Checkbox checked={isActive} onChange={handleIsActive} />
            </Grid>
            <Grid item xs={12} mt={2}>
              Is Ticket Report Enabled?
              <Checkbox
                checked={isReportEnabled}
                onChange={handleIsReportEnabled}
              />{" "}
              {isReportEnabled && (
                <>
                  <Link
                    href="#"
                    underline="none"
                    component="button"
                    onClick={handleOpenModal}
                  >
                    Add customer reports data
                  </Link>
                  <span style={{ color: "red" }}> (***Bora Reports Only.)</span>
                </>
              )}
            </Grid>
             <Grid item xs={12} mt={2}>
              <FormControl>
                <FormLabel sx={{ color: "black !important" }}>
                  Please choose one of the ticket report languages.
                </FormLabel>
                <RadioGroup
                  row
                  defaultValue={reportLanguage}
                  value={reportLanguage}
                  onChange={handleReportLanguage}
                >
                  {languageOptionsForReport.map((option) => (
                    <FormControlLabel
                      key={option.value}
                      value={option.value}
                      control={<Radio />}
                      label={option.label}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} mt={2}>
              <FormControl>
                <FormLabel sx={{ color: "black !important" }}>
                  Language
                </FormLabel>
                <RadioGroup
                  row
                  defaultValue={language}
                  value={language}
                  onChange={handleLanguage}
                >
                  {languageOptions.map((option) => (
                    <FormControlLabel
                      key={option.value}
                      value={option.value}
                      control={<Radio />}
                      label={option.label}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                Email Address (One email per line){" "}
                <span style={{ color: "red" }}>*</span>
              </Grid>
              <Grid item xs={6} mt={1}>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  onChange={handleEmail}
                  value={email ? email.split(" ").join("\n") : ""}
                  error={!!emailError}
                  helperText={emailError}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                CC (One email per line) <span style={{ color: "red" }}>*</span>
              </Grid>
              <Grid item xs={6} mt={1}>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  onChange={handleCC}
                  value={cc ? cc.split(" ").join("\n") : ""}
                  error={!!ccError}
                  helperText={ccError}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                Pccs (One pcc per line) <span style={{ color: "red" }}>*</span>
              </Grid>
              <Grid item xs={6} mt={1}>
                <TextField
                  fullWidth
                  multiline
                  rows={6}
                  onChange={handlePCCs}
                  value={PCCs ? PCCs.split(" ").join("\n") : ""}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                Address 1 <span style={{ color: "red" }}>*</span>
              </Grid>
              <Grid item xs={6} mt={1}>
                <TextField
                  fullWidth
                  value={address1}
                  onChange={(e) => setAddress1(e.target.value)}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                Address 2 <span style={{ color: "red" }}>*</span>
              </Grid>
              <Grid item xs={6} mt={1}>
                <TextField
                  fullWidth
                  value={address2}
                  onChange={(e) => setAddress2(e.target.value)}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                City <span style={{ color: "red" }}>*</span>
              </Grid>
              <Grid item xs={6} mt={1}>
                <TextField
                  fullWidth
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                Postal Code <span style={{ color: "red" }}>*</span>
              </Grid>
              <Grid item xs={6} mt={1}>
                <TextField
                  fullWidth
                  value={postalCode}
                  inputProps={{ maxLength: 10 }}
                  onChange={handlePostalCodeChange}
                  error={!!postalCodeError}
                  helperText={postalCodeError}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                Country (Wait to load the countries){" "}
                <span style={{ color: "red" }}>*</span>
              </Grid>
              <Grid item xs={6} mt={1}>
                <Autocomplete
                  fullWidth
                  options={countries.map((country) => country?.name?.trim())}
                  value={country}
                  onChange={(event, newValue) => setCountry(newValue)}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                Telephone Number <span style={{ color: "red" }}>*</span>
              </Grid>
              <Grid item xs={6} mt={1}>
                <TextField
                  fullWidth
                  value={telephone_number}
                  inputProps={{ maxLength: 18 }}
                  onChange={handleTelephoneNumberChange}
                  error={!!telephoneNumberError}
                  helperText={telephoneNumberError}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                Contact Person <span style={{ color: "red" }}>*</span>
              </Grid>
              <Grid item xs={6} mt={1}>
                <TextField
                  fullWidth
                  value={contact_person}
                  onChange={(e) => setContact_person(e.target.value)}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Button
                variant="contained"
                type="submit"
                sx={{ backgroundColor: "#282828" }}
                onClick={submitHandler}
              >
                Save
              </Button>
            </Grid>
          </Grid>
          <Modal open={openModal} onClose={handleCloseModal}>
            <Box sx={modalStyle}>
              <Grid container>
                <Grid
                  xs={12}
                  sx={{ textAlign: "center", marginBottom: 4, fontSize: 25 }}
                >
                  Add customer reports data
                </Grid>
              </Grid>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  marginLeft: 5,
                }}
              >
                <Box>
                  <Grid
                    container
                    sx={{ display: "flex", justifyContent: "left" }}
                  >
                    <Grid xs={12}>
                      <TextField
                        size="small"
                        label="Suppliers"
                        placeholder="e.g., 1G"
                        value={suppliers}
                        onChange={(e) => {
                          setSuppliers(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid xs={12} mt={3}>
                      <TextField
                        size="small"
                        label="Client"
                        placeholder="e.g., 411DIVERS"
                        value={client}
                        onChange={(e) => {
                          setClient(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid xs={12} mt={3}>
                      <TextField
                        size="small"
                        label="Type"
                        placeholder="e.g., ATB"
                        value={type}
                        onChange={(e) => {
                          setType(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid xs={12} mt={3}>
                      <TextField
                        size="small"
                        label="Destination"
                        placeholder="e.g., INTERNATIONAL"
                        value={destination}
                        onChange={(e) => {
                          setDestination(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid xs={12} mt={3}>
                      <TextField
                        size="small"
                        label="Total Fares"
                        placeholder="e.g., 0"
                        value={total_fares}
                        onChange={(e) => {
                          setTotal_Fares(e.target.value);
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
                <Box>
                  <Grid container>
                    <Grid xs={12}>
                      <TextField
                        size="small"
                        label="Discount"
                        placeholder="e.g., 0"
                        value={discount}
                        onChange={(e) => {
                          setDiscount(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid xs={12} mt={3}>
                      <TextField
                        size="small"
                        label="Form Of Payment"
                        placeholder="e.g., NONREF"
                        value={fop}
                        onChange={(e) => {
                          setFOP(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid xs={12} mt={3}>
                      <TextField
                        size="small"
                        label="ETKT"
                        placeholder="e.g., OUI"
                        value={etkt}
                        onChange={(e) => {
                          setETKT(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid xs={12} mt={3}>
                      <TextField
                        size="small"
                        label="Office ID"
                        placeholder="e.g., DKR272800"
                        value={office_id}
                        onChange={(e) => {
                          setOffice_id(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid xs={12} mt={3}>
                      <TextField
                        size="small"
                        label="GDS"
                        placeholder="e.g., GALILEO"
                        value={gds}
                        onChange={(e) => {
                          setGDS(e.target.value);
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              <Box mt={4} sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ backgroundColor: "#282828", width: "30%" }}
                  onClick={handleCloseModal}
                >
                  Save
                </Button>
              </Box>
            </Box>
          </Modal>
          <Dialog
            open={saveMessageOpen}
            onClose={handleSaveMessageCancel}
            aria-labelledby="customer-save-message-title"
          >
            <DialogTitle id="customer-save-message-title">Success</DialogTitle>
            <DialogContent>
              <DialogContentText>{saveMessage}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleSaveMessageCancel} autoFocus>
                OK
              </Button>
            </DialogActions>
          </Dialog>
          {customerInfo && (
            <Snackbar
              open={snackOpen && !saveMessageOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="success"
                sx={{ width: "100%" }}
              >
                <AlertTitle>Success</AlertTitle>
                {customerInfo}
              </Alert>
            </Snackbar>
          )}
          {error && (
            <Snackbar
              open={snackOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="error"
                sx={{ width: "100%" }}
              >
                <AlertTitle>Error</AlertTitle>
                {error}
              </Alert>
            </Snackbar>
          )}
          {errorAlert && (
            <Snackbar
              open={snackOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="error"
                sx={{ width: "100%" }}
              >
                <AlertTitle>{errorAlertTitle}</AlertTitle>
                {errorAlertMessage}
              </Alert>
            </Snackbar>
          )}
          {success && message && (
            <Snackbar
              open={snackOpen && !saveMessageOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="success"
                sx={{ width: "100%" }}
              >
                <AlertTitle>Success</AlertTitle>
                {message}
              </Alert>
            </Snackbar>
          )}
          {updateerror && (
            <Snackbar
              open={snackOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="error"
                sx={{ width: "100%" }}
              >
                <AlertTitle>Error</AlertTitle>
                {updateerror}
              </Alert>
            </Snackbar>
          )}
        </Box>
      </Box>
    </Container>
  );
}
